import { FC, Fragment, useEffect, useMemo, useState } from 'react'
import PopupContainer from 'src/component/popup/PopupContainer'
import { useGet } from 'src/hooks/useGet'
import { GetPatientHospitals } from 'src/requests/Shared'
import { GetLoadMedicalFiles } from 'src/requests/PatientMedicalFiles'
import DropDown from 'src/component/DropDown'
import { Lookup } from 'src/common/Common.Type'
import ImgsGallery from 'src/component/ImgGallery'
import { useTranslation } from 'react-i18next'
import TabSwitch from 'src/component/TabSwitch'
import PdfFileCard from './DataCard'
import PatientFilesGallery from './DataCard/PatientFilesGallery'

interface IMedicalServicesPopup {
    modalId: any
    patientId: number | null
}


const ImgsFileType = "IMAGE"
const PDGFileType = "PDF"


const TabsIDs = {
    PDF: 1,
    IMAGE: 2
}


const FilesTypes = [{ label: "IMAGE", value: TabsIDs.IMAGE }, { label: "PDF", value: TabsIDs.PDF }]

const medicalService = 'medicalService'

const MedicalFilesPopup: FC<IMedicalServicesPopup> = ({ patientId, modalId }) => {

    const { t } = useTranslation()

    const { data: patientHospitals } = useGet({ API: GetPatientHospitals, isNotValid: !patientId, depArr: [patientId], params: [patientId], defaultValue: [] })

    const [hospitalId, setHospitalId] = useState<Lookup | null>(null)

    const [tab, setTab] = useState(TabsIDs?.IMAGE)

    const { data: LoadedFiles } = useGet({ API: GetLoadMedicalFiles, isNotValid: !patientId || !hospitalId, depArr: [patientId, hospitalId], params: [patientId, hospitalId?.value], defaultValue: [] })

    const ImgsList = useMemo(() => LoadedFiles.filter((file: any) => file.fileType == ImgsFileType), [LoadedFiles])
    const PDFsList = useMemo(() => LoadedFiles.filter((file: any) => file.fileType == PDGFileType), [LoadedFiles])

    useEffect(() => {
        setHospitalId(patientHospitals.length == 1 ? patientHospitals[0] : null)
    }, [patientHospitals])


    const handleOpenPDF = (link: string) => {
        window.open(`${window.API_URL}/${link}`, "_blank", "noopener , noreferrer")

    }


    return (
        <PopupContainer Name='add-medicine' recordID={patientId} modalID={modalId} modalName={medicalService} >

            <DropDown label='hospital' placeholder='hospital' options={patientHospitals} setVal={setHospitalId} val={hospitalId} />

            {!!LoadedFiles.length && hospitalId?.value &&
                < TabSwitch Tabs={FilesTypes} setTab={setTab} defaultSelect={TabsIDs?.IMAGE} />
            }

            {ImgsList?.length > 0 && tab == TabsIDs?.IMAGE ? <>
                <span className='w-fit-content d-block'>{t(`click-img-to-open`)}</span>
                <PatientFilesGallery   ImgsList={ImgsList} modalId={modalId}/>
            </>
               
                : ""}
            {PDFsList?.length > 0 && tab == TabsIDs?.PDF ?
                <>
                    <div className='w-fit-content d-block'>{t(`click-pdf-to-open`)}</div>
                    <div>
                        {//@ts-ignore
                            PDFsList.map((pdfFile, index) => <Fragment key={index} ><PdfFileCard file={pdfFile} /></Fragment >)}
                    </div>
                </>
                :
                ""}


        </PopupContainer >
    )
}

export default MedicalFilesPopup